// responsibility - handle logout expiration events
import AuthEngine from '@/plugins/msal'
import * as Sentry from '@sentry/browser'
import { useAppStore } from '../app'
import type { PiniaPluginContext } from 'pinia'

let logoutCheckInterval: NodeJS.Timeout | null = null

const identityStatusMonitor = ({ store }: PiniaPluginContext) => {
  // Only apply to the app store
  if (store.$id !== 'app') return

  async function setMsToExpire() {
    try {
      const loginExpiration = await AuthEngine.loginExpiration()
      if (loginExpiration) {
        const msToExpire = (loginExpiration as unknown as number) - Date.now()
        
        const appStore = useAppStore()
        appStore.setUserMsToExpire(msToExpire)
      }
    } catch (e) {
      Sentry.captureException(e)
    }
  }

  function startMonitoring() {
    setMsToExpire()
    if (logoutCheckInterval) {
      clearInterval(logoutCheckInterval)
    }
    logoutCheckInterval = setInterval(() => { 
      setMsToExpire() 
    }, 10000)
  }

  function stopMonitoring() { 
    if (logoutCheckInterval) {
      clearInterval(logoutCheckInterval)
      logoutCheckInterval = null
    }
  }

  // Watch for user changes
  store.$subscribe((_mutation, state) => {
    const userState = (state as any).user
    
    if (userState !== null) {
      const msToExpire = userState.msToExpire
      if (msToExpire === undefined) {
        startMonitoring()
      } else if (msToExpire !== undefined && msToExpire <= 0) {
        stopMonitoring()
        AuthEngine.logout()
      }
    } else {
      stopMonitoring()
    }
  }, { deep: true })
}

export default identityStatusMonitor